export default {
    approvalInquiry: 'อนุมัติทำงานนอกสถานที่',
    approvalLeave: 'อนุมัติคำร้องขอลา',
    typeInquiry: 'ประเภทคำร้องขอ',
    status: 'สถานะ',
    allType: 'ทุกประเภท',
    employeeNo: 'รหัสพนักงาน',
    name: 'ชื่อ',
    date: 'วันที่',
    leaveType: 'ประเภท',
    description: 'สาเหตุ',
    approve: 'อนุมัติ',
    reject: 'ไม่อนุมัติ',
    personalLeave: 'ลากิจ',
    sickLeave: 'ลาป่วย',
    onSite: 'เข้าหน้างาน',
    allTypeMessage: 'ลาหรือขอไปทำงานนอกสถานที่',
    inquiryMessageType: 'ไม่พบข้อมูลการขอ$typeของวันที่ ',
    msgSuccess: 'บันทึกสำเร็จ',
    requireRemark: 'กรุณากรอก Remark ก่อนปฏิเสธ',
    cannotGetLineId: 'เกิดข้อผิดพลาด'
}
